import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { change, FieldArray, reduxForm } from 'redux-form';

import { Typography } from '@material-ui/core';

import ActivitiesList from '../activities-list/ActivitiesList';
import BookingInformation from '../booking-information/BookingInformation';
import ActivityDialog from '../related-product-dialog/activity-dialog/ActivityDialog';
import AccommodationDialog from '../related-product-dialog/accommodation-dialog/AccommodationDialog';

import useStyles from './styles';

const initialValues = {
  activities: []
};

const Products = ({
  productData,
  widgetForm,
  changeFormFieldValue,
  handleSubmit,
  isAccommodationBooking,
  ownerId,
  logo
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const [isOpenProductDialog, setIsOpenProductDialog] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState(null);

  const currency = widgetForm.values.currency;

  React.useEffect(() => {
    setActivities(productData);
  }, [productData]);

  const setActivities = product => {
    const relatedProducts = isAccommodationBooking
      ? product.relatedActivitiesForm.relatedActivities
      : product.relatedAccommodationsForm.relatedAccommodations;

    const createdRelatedProducts = widgetForm.values.activities;

    if (createdRelatedProducts && createdRelatedProducts.length) return;

    changeFormFieldValue('activities', relatedProducts);
  };

  const selectProduct = (item, index) => {
    setSelectedProduct({
      ...item,
      index: index
    });
    setIsOpenProductDialog(true);
  };

  const closeProductDialog = () => {
    setIsOpenProductDialog(false);
  };

  return (
    <div className={classes.wrapper}>
      {isAccommodationBooking ? (
        <div>
          {isOpenProductDialog && (
            <ActivityDialog
              ownerId={ownerId}
              open={isOpenProductDialog}
              initialValues={selectedProduct}
              closeDialogCallback={closeProductDialog}
              accommodationData={productData}
              logo={logo}
            />
          )}
        </div>
      ) : (
        <div>
          {isOpenProductDialog && (
            <AccommodationDialog
              ownerId={ownerId}
              open={isOpenProductDialog}
              initialValues={selectedProduct}
              closeDialogCallback={closeProductDialog}
              activityData={productData}
              logo={logo}
            />
          )}
        </div>
      )}

      <div className={classes.leftSide}>
        <form onSubmit={handleSubmit}>
          <Typography
            variant="h3"
            classes={{ root: classes.sectionTitleIndent }}
          >
            {isAccommodationBooking
              ? t('Select activities')
              : t('Select accommodations')}
          </Typography>
          <FieldArray
            name="activities"
            component={ActivitiesList}
            selectCallback={selectProduct}
            currency={currency}
          />
        </form>
      </div>
      <div className={classes.rightSide}>
        <BookingInformation data={productData} form={widgetForm} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    widgetForm: state.form.widgetForm
  };
};

const mapDispatchToProps = dispatch => ({
  changeFormFieldValue: (field, value) => {
    dispatch(change('widgetForm', field, value));
  }
});

export default reduxForm({
  form: 'widgetForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  initialValues
})(connect(mapStateToProps, mapDispatchToProps)(Products));
